import {
  FETCH_HEALTH_STATUS_REQUEST,
  FETCH_HEALTH_STATUS_SUCCESS,
  FETCH_HEALTH_STATUS_FAILURE,
} from '../../constants/ActionTypes';
import healthApi from '../../api/health-status';
import { isHealthStatusFetching } from '../getters/health-status';
import { getAlgos } from '../getters/algos';
import {
  getAlgosUniversal,
  getAlgoUniversalById,
} from '../getters/algos-universal';
import { getFormattedPageHash } from '../../utils';
import { getBrokers } from '../getters/config';

const getHealthParams = (getState) => {
  const services = [];
  const algos = getAlgos(getState());
  const algosUniversal = getAlgosUniversal(getState());
  const { _id: algoUniversalId = '' } = getAlgoUniversalById(getState());

  if (window.location.pathname.includes('/users/')) {
    const { day = 'MON', tab = '' } = getFormattedPageHash();

    if (tab === 'algos') {
      const filteredAlgo = algos.filter((a) => a.day && a.day === day) || [];

      if (filteredAlgo.length) {
        filteredAlgo.forEach((a) => {
          services.push({
            service: 'algo',
            id: a._id,
          });
        });
      }
    }
  } else if (
    algoUniversalId &&
    window.location.pathname.includes(`/algos/${algoUniversalId}`)
  ) {
    services.push({
      service: 'algo',
      id: algoUniversalId,
    });
  } else if (window.location.pathname.includes('/algos')) {
    algosUniversal.forEach((a) => {
      services.push({
        service: 'algo',
        id: a._id,
      });
    });
  }

  return services;
};

export const fetchHealthStatus = () => (dispatch, getState) => {
  if (isHealthStatusFetching(getState())) {
    return Promise.resolve();
  }

  dispatch({
    type: FETCH_HEALTH_STATUS_REQUEST,
  });

  const brokers = getBrokers(getState());
  const brokersFiltred = brokers.filter(
    (item) => item.name !== 'forward-testing'
  );

  const brokerNames =
    brokersFiltred && brokersFiltred.length
      ? brokersFiltred.map((b) => b.name)
      : [];

  const params = getHealthParams(getState);

  return healthApi
    .getHealthStatus(brokerNames, params)
    .then((data) => {
      return dispatch({
        type: FETCH_HEALTH_STATUS_SUCCESS,
        data,
      });
    })
    .catch((error) => {
      return dispatch({
        type: FETCH_HEALTH_STATUS_FAILURE,
        data: error,
      });
    });
};
